import React from "react";

import { LocalisationProvider } from "@hooks/useLocalisation";

interface Props {
  children: React.ReactNode;
}

const LanguageDetector = (props: Props): React.ReactElement => {
  return <LocalisationProvider>{props.children}</LocalisationProvider>;
};

export { LanguageDetector };
